import { SITE_CORE_URL } from '@shared/constants/paths';

import { MEDICATIONS_DEVICES_AND_TREATMENTS_LINKS } from '../../constants';
import Linkout from '../Linkout';

const MedicationsDevicesTreatment = () => (
  <div className="flex w-full">
    <Linkout
      className="grid-cols-1 lg:grid-cols-4"
      containerClassName="w-full"
      links={MEDICATIONS_DEVICES_AND_TREATMENTS_LINKS}
      title="Medications"
      viewAllUrl={SITE_CORE_URL.medicationsDevices}
    />
  </div>
);

export default MedicationsDevicesTreatment;
